import axios from "axios"
import ApiStore from "./ApiStore";
// var querystring = require('querystring');

export class AssetStore extends ApiStore{
  constructor() {
    super();
    this.state = {}
  }

  loadReportAsset(completeFunc){
    axios.get('/asset/report_asset')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadReportWorkByVehicle(vehicleId,completeFunc){
    axios.get('/asset/report_work?vehicle_id='+vehicleId)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadReportAssetBySearch(q,cat_id,sub_cat_id,completeFunc){
    axios.get('/asset/report_asset?q='+q+'&cat_id='+cat_id+'&sub_cat_id='+sub_cat_id)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadReportAssetInfo(asset_id,completeFunc){
    let url = '/asset/info'
    if (asset_id!=='')
      url = '/asset/info/'+asset_id
    axios.get(url)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveAssetInfo(asset_id,postData,completeFunc,errorFunc){
    
    console.log('postData',postData)    
    axios.post('/asset/info/'+asset_id,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  } 

  delAssetInfo(asset_id,completeFunc,errorFunc){
    axios.delete('/asset/info/'+asset_id)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadReportAssetCategory(cat_id,completeFunc){
    let url = '/asset/category'
    if (cat_id!=='')
      url = '/asset/category/'+cat_id
    axios.get(url)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveAssetCategory(cat_id,postData,completeFunc,errorFunc){
    let url = '/asset/category'
    if (cat_id!=='')
      url = '/asset/category/'+cat_id
    console.log('postData',postData)    
    axios.post(url,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }

  deleteAssetCategory(cat_id,completeFunc,errorFunc){
    axios.delete('/asset/category/'+cat_id)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }
}  

export default new AssetStore()


// WEBPACK FOOTER //
// ./src/stores/AssetStore.js